module.exports = __webpack_public_path__ + "/images/shop/icon/carte_bancaire.svg";